export default __webpack_public_path__ + "static/media/companies2.13c12592.png";